import { Line } from '@components'
import { Card } from '@ss/meta-core-components'
import React from 'react'

import { Serie } from '@nivo/line'
import styled from '@emotion/styled'
import { StatisticsIcon } from '../../assets/icons/statisticsIcon'

interface Props {
  data?: Serie[]
  legend?: { x: string; y: string }
  name?: string
  domain?: { max: number; min: number }
  CI: string
}

/**
 * Componente contenente il grafico Line della pagina TimeSeries
 * @param props.data {(Serie[])=} parametri per la richiesta dei dati
 * @param props.legend {({ x: string, y: string })=} legenda assi
 * @param props.name {string=} nome start-up
 * @param props.domain {({ max: number, min: number })=} min e max per il grafico
 * @param props.CI {string} codice fiscale
 * @component
 */
export const TimeSeriesChart: React.FC<Props> = (props) => {
  const { data, legend, name, domain, CI } = props

  return (
    <Card width={'64%'} height={'500px'}>
      <Title>
        <div style={{ placeSelf: 'center' }}>
          <StatisticsIcon />
        </div>
        <div
          data-cy={'line-chart-title'}
        >{`Economical Values of codice fiscale ${CI} ( ${name} )`}</div>
      </Title>
      {data ? (
        <Line
          yFormat={'KGM'}
          data={data}
          axisLegend={legend}
          dataCy={'time-series'}
          domain={domain}
          dimensions={{ height: '400px' }}
          margin={{ top: 20, right: 60, bottom: 60, left: 90 }}
        />
      ) : (
        <></>
      )}
    </Card>
  )
}

//region STYLE
const Title = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 18.022px;
  line-height: 22px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: 45px auto;
  gap: 30px;
`
//endregion
